/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0815/6210/8187/files/20250702-p1.png",
    "https://cdn.shopify.com/s/files/1/0815/6210/8187/files/20250702-p2.png",
    "https://cdn.shopify.com/s/files/1/0815/6210/8187/files/20250702-p3.png",

    "https://cdn.shopify.com/s/files/1/0815/6210/8187/files/20250702-b1.png",
    "https://cdn.shopify.com/s/files/1/0815/6210/8187/files/20250702-b2.png",
    "https://cdn.shopify.com/s/files/1/0815/6210/8187/files/20250702-b3.png",
    "https://cdn.shopify.com/s/files/1/0815/6210/8187/files/20250702-b4.png",
    "https://cdn.shopify.com/s/files/1/0815/6210/8187/files/20250702-b5.png",
  ];

  var thumbsp = new Swiper(".sp-swiper-thumbs", {
    // direction: "vertical",
    spaceBetween: 22,
    slidesPerView: 5,

    watchSlidesVisibility: true, //防止不可点击
  });
  new Swiper("#swiper-p1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    thumbs: {
      swiper: thumbsp,
    },

    // speed: 1,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");

      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
        config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();
  const swiper2 = new Swiper('#dialog-swiper', {
    // 滑动内容之间的间距
    spaceBetween: 20,
    // 容器左侧内边距（距离左边）
    padding: {
      left: 30,
      // 容器右侧内边距（距离右边）
      right: 30
    },
    navigation: {
      nextEl: `.swiper-button-next`,
      prevEl: `.swiper-button-prev`,
    },
    // 其他配置...
    slidesPerView: 'auto', // 自适应宽度，配合padding实现边距效果
    // slidesPerView: 2, // 移动端一屏显示2个（结合你的需求）
  });
  // 弹窗 start
  var main_id = "";
  var main_num = 1
  $('.emitCheckout').click(function () {
    console.log('1111')
    main_id = $(this).data('id')
    let index = $(this).data("index")
    if (!index) {
      main_num = $('#calcNumber').val()
    }
    // main_id = $(this).siblings('.select_span').find('span.on').data('id')
    // window.location.href = "/cart/" + id + ":1"
  })

  function getPopProdId() {
    let selectVals = [];
    $('.overbuy_wrap .sp-subopt.active').each(function () {
      selectVals.push($(this).data('val'))
    })

    let cur = popProduct.filter(item => {
      let option1 = selectVals[0];
      let option2 = null;
      let option3 = null;
      if (selectVals[1]) {
        option2 = selectVals[1];
      }
      if (selectVals[2]) {
        option3 = selectVals[2];
      }


      return item.option1 == option1 && item.option2 == option2 && item.option3 == option3
    })



    return cur[0];
  }

  $('.overbuy-select div').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    let cur = getPopProdId();

    if (cur) {
      $(".main-btn").text('GET 10% oFF').removeClass("overbuy_disabled")
      let _price = parseFloat(cur.price / 100).toFixed(2);
      let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(2);

      $('.overbuy_price span').eq(0).html('£' + _price);
      $('.overbuy_price span').eq(1).html('£' + _compare_at_price);
    } else {
      $(".main-btn").text("Unavailable").addClass("overbuy_disabled")
    }

  })




  window.emitSubmit = function (_type) {
    if (_type == 'all') {
      // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
      let _id = getPopProdId()?.id;
      if (!_id) return
      console.log(_id)

      window.location.href = `/cart/${main_id}:${main_num},${_id}:1`
    } else {
      window.location.href = `/cart/${main_id}:${main_num}`
    }
  }



  // 弹窗 end
  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  const spul = document.getElementById("spul");

  const splis = spul.querySelectorAll(".sp-li");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 给每个 span 和 i 动画
          splis.forEach((span, index) => {
            const sp1 = span.querySelector(".sp-circle");
            const sp2 = span.querySelector(".sp-tick");
            const sp3 = span.querySelector("p");

            if (sp1) {
              sp1.style.animation = `sp-circle 1s ease-in-out forwards`;
              sp1.style.animationDelay = `${index * 1}s`;
            }
            if (sp2) {
              sp2.style.animation = `sp-tick 0.8s ease-out forwards 0.95s`;
              sp2.style.animationDelay = `${index * 1 + 0.95}s`;
            }
            if (sp3) {
              sp3.style.animation = `sp-title-ani 0.6s ease-in-out forwards 1.2s`;
              sp3.style.animationDelay = `${index * 1 + 1.2}s`;
            }
          });

          observer.unobserve(spul);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observer.observe(spul);

  const spul2 = document.getElementById("spul2");

  const splis2 = spul2.querySelectorAll(".sp-li");

  const observer2 = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 给每个 span 和 i 动画
          splis2.forEach((span, index) => {
            const sp1 = span.querySelector(".sp-circle");
            const sp2 = span.querySelector(".sp-tick");
            const sp3 = span.querySelector("p");

            if (sp1) {
              sp1.style.animation = `sp-circle 1s ease-in-out forwards`;
              sp1.style.animationDelay = `${index * 1}s`;
            }
            if (sp2) {
              sp2.style.animation = `sp-tick 0.8s ease-out forwards 0.95s`;
              sp2.style.animationDelay = `${index * 1 + 0.95}s`;
            }
            if (sp3) {
              sp3.style.animation = `sp-title-ani 0.6s ease-in-out forwards 1.2s`;
              sp3.style.animationDelay = `${index * 1 + 1.2}s`;
            }
          });

          observer2.unobserve(spul2);
        }
      });
    },
    {
      threshold: 0.3,
    }
  );
  observer2.observe(spul2);

  let sp_price1 = window.prods[0].price / 100;
  let sp_price2 = window.prods[0].compare_at_price / 100;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  $('.sp-btn-style').click(function () {
    let num = $(this).siblings(".addGroup").find("input").val()
    num = num ? num : 1;
    window.location.href = '/cart/' + $(this).attr("data-id") + ':' + num
  })
  function showTip() {
    // let result = $("#sp_price1").html();
    // if (result >= 50) {
    //   $(".product-part .sp-btn-tip").show();
    // } else {
    //   $(".product-part .sp-btn-tip").hide();
    // }
  }
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    // $("#sp_price1").html(calcTotal(sp_price1, input.value));
    // $("#sp_price2").html(calcTotal(sp_price2, input.value));
    showTip();
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    // $("#sp_price1").html(calcTotal(sp_price1, input.value));
    // $("#sp_price2").html(calcTotal(sp_price2, input.value));
    showTip();
  });
});
